// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"111":"746c89bb","154":"2b6ad8d1","711":"85f87f4a","955":"f06582cd"}[chunkId] + ".chunk.css";
};